import { render, staticRenderFns } from "./account.vue?vue&type=template&id=778abfab&scoped=true&"
import script from "./account.vue?vue&type=script&lang=js&"
export * from "./account.vue?vue&type=script&lang=js&"
import style0 from "./account.vue?vue&type=style&index=0&id=778abfab&prod&lang=css&"
import style1 from "./account.vue?vue&type=style&index=1&id=778abfab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778abfab",
  null
  
)

export default component.exports